// componente per la visualizzazione della pagina di inserimento/modifica di un pannello (componente sinistra)
// nella pagina "Pannelli"

import { Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/service/alert.service';

import { ApiService } from '../../../../service/api.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';

import { Plants } from '../plants.model';
import { PlantsService } from '../plants.service';
import { PlantsListComponent } from '../plants-list/plants-list.component';
import { PlantsComponent } from '../plants.component';

@Component({
  selector: 'app-plants-edit',
  templateUrl: './plants-edit.component.html',
  styleUrls: ['./style.scss']
})
export class PlantsEditComponent implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) plantsForm: NgForm;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode = false; // variabile posta a true se è attiva la modifica di un pannello
  oldId = 0; // ID del pannello prima della modifica
  editPlantsId = 0; // ID del pannello da modificare
  plants: Plants; // pannello selezionato
  comment = ''; // commento pannello preimpostato come stringa vuota
  profile: string // profilo utente
  bodyid: string // id ente
  groupids: string[]
  bodies
  emailAlredyExist = "";
  cards = []
  constructor(private als: AlertService,public plantsComponent: PlantsComponent, private plantsService: PlantsService, private plantsList: PlantsListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  emailCheckUnique() {
    if (this.cards.includes(this.plantsForm.value.plantid)) {
      this.emailAlredyExist = "ID impianto già esistente";
    }
    else {
      this.emailAlredyExist = "";
    }
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this
    this.dataStorageService.getPlantsTot().subscribe(p => {
      p.forEach(v => {
        this.cards.push(v.plantid)
      })
    })
    this.dataStorageService.getGroupsList().subscribe(v => {
      this.groupids = v
      if (me.plantsService.plant) {
        setTimeout(() => {
          me.plants = me.plantsService.plant
          var groups = []
          if (me.plants.groupid) {
            if (me.plants.groupid.includes('[')) {
              //@ts-ignore
              var temp = me.plants.groupid.substring(1, me.plants.groupid.length-1);
              temp = temp.split(",")
              temp.forEach(t => {
                groups.push(t.replace(" ", ""))
              })
            } else {
              groups.push(me.plants.groupid)
            }
          }
          groups.forEach((t,i) => {
            var el = v.find(a => a.includes(t))
            groups[i] = el
          })
          me.profile == 'SuperAdmin' ? me.plantsForm.setValue({
            plantid: me.plants.plantid ? me.plants.plantid : "",
            groupid: groups,
            alias: me.plants.alias ? me.plants.alias : "",
            name: me.plants.name ? me.plants.name : "",
            address: me.plants.address ? me.plants.address : "",
            latitude: me.plants.latitude ? me.plants.latitude : 0,
            longitude: me.plants.longitude ? me.plants.longitude : 0,
            modem: me.plants.modem ? me.plants.modem : "",
            planttype: me.plants.planttype ? me.plants.planttype : "",
            email: me.plants.email ? me.plants.email : "",
            bodyid: me.plants.bodyid ? me.plants.bodyid : "",
            tag: me.plants.tag ? me.plants.tag : "",
            enabled: me.plants.enabled ? true : false,
          }) : me.plantsForm.setValue({
            plantid: me.plants.plantid ? me.plants.plantid : "",
            groupid: groups,
            alias: me.plants.alias ? me.plants.alias : "",
            name: me.plants.name ? me.plants.name : "",
            address: me.plants.address ? me.plants.address : "",
            latitude: me.plants.latitude ? me.plants.latitude : 0,
            longitude: me.plants.longitude ? me.plants.longitude : 0,
            modem: me.plants.modem ? me.plants.modem : "",
            planttype: me.plants.planttype ? me.plants.planttype : "",
            email: me.plants.email ? me.plants.email : "",
            tag: me.plants.tag ? me.plants.tag : "",
            enabled: me.plants.enabled ? true : false,
          })
          me.editPlantsId = me.plantsService.plantsId;
          me.editMode = true;

        }, 100)

      }
    })

    // // si riempie la form coi valori preimpostati
    // me.subscription = me.plantsService.plantsEditMode.subscribe(
    //   (id: number) => {
    //     me.plants = me.plantsService.getPlantsByIndex(id);
    //     me.oldId = me.plants.id
    //     var groups = []
    //     if (me.plants.groupid) {
    //       //@ts-ignore
    //       me.plants.groupid.includes('[') ? groups = JSON.parse(me.plants.groupid) : groups.push(me.plants.groupid)
    //     }
    //     groups.forEach(v => {
    //       var el = me.groupids.find(a => a.includes(v))
    //       v = el
    //     })
    //     me.plantsForm.setValue({
    //       plantid: me.plants.plantid ? me.plants.plantid : "",
    //       groupid: groups,
    //       alias: me.plants.alias ? me.plants.alias : "",
    //       name: me.plants.name ? me.plants.name : "",
    //       address: me.plants.address ? me.plants.address : "",
    //       latitude: me.plants.latitude ? me.plants.latitude : 0,
    //       longitude: me.plants.longitude ? me.plants.longitude : 0,
    //       modem: me.plants.modem ? me.plants.modem : "",
    //       planttype: me.plants.planttype ? me.plants.planttype : "",
    //       email: me.plants.email ? me.plants.email : "",
    //       bodyid: me.plants.bodyid ? me.plants.bodyid : "",
    //       tag: me.plants.tag ? me.plants.tag : "",
    //     });
    //     me.editPlantsId = id;
    //     me.editMode = true;
    //   }
    // );

    this.dataStorageService.getBodyList().subscribe(v => {
      this.bodies = v
    })
    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profile = this.auth.currentUserValue.profile
    this.bodyid = this.auth.currentUserValue.bodyid

  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    var body
    me.profile == 'SuperAdmin' ? body = value.bodyid : body = undefined
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxPlants().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Plants(v,
          value.plantid,
          value.groupid,
          value.alias,
          value.name,
          value.address,
          value.latitude,
          value.longitude,
          value.modem,
          value.planttype,
          value.email,
          body,
          value.tag,
          value.enabled,
        );

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storePlants(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.plants = mess;
        me.plantsService.addPlants(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.dataStorageService.getPlants();
          me.utilsService.hideLoader();
          me.onClear();
          me.change()
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_plants = new Plants(me.editPlantsId,
        value.plantid,
        value.groupid,
        value.alias,
        value.name,
        value.address,
        value.latitude,
        value.longitude,
        value.modem,
        value.planttype,
        value.email,
        body,
        value.tag,
        value.enabled,
      );

      // si richiamano i servizi di aggiornamento tabella
      me.plants = new_plants;
      me.plants.id = me.editPlantsId;
      var res = this.plantsList.getIndex(this.plants.id)
      me.plantsService.updatePlants(res, me.plants);

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updatePlants(me.plants)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.dataStorageService.getPlants();
        me.utilsService.hideLoader();
        me.onClear();
        me.change()
      }, 1000)
    }
  }
  isEdit() {
    return this.plantsComponent.isedit
  }
  change() {
    this.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    this.plantsService.plant = undefined
    this.onClear();
    this.plantsComponent.isedit = !this.plantsComponent.isedit
    this.utilsService.hideLoader(); // viene mostrata l'animazione di caricamento
  }
  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    var me = this
    me.profile == 'SuperAdmin' ? me.plantsForm.setValue({
      plantid: '',
      groupid: '',
      alias: '',
      name: '',
      address: '',
      latitude: 0,
      longitude: 0,
      modem: '',
      planttype: '',
      email: '',
      bodyid: '',
      tag: '',
      enabled: ''
    }) : me.plantsForm.setValue({
      plantid: '',
      groupid: '',
      alias: '',
      name: '',
      address: '',
      latitude: 0,
      longitude: 0,
      modem: '',
      planttype: '',
      email: '',
      tag: '',
      enabled: ''
    })
    me.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = this.als.confirm("Sei sicuro di voler eliminare l'impianto?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deletePlants(me.plants.id)
  
        // ...il messaggio viene eliminato dalla tabella...
        me.plantsService.deletePlants(me.plants.id);
  
        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;
  
        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.change()
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });

  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
  import() {
    var me = this
    const dialogRef = this.dialog.open(Upload6, {});
    dialogRef.afterClosed().subscribe(result => {
      me.dataStorageService.getPlants();
      me.change()
      me.utilsService.hideLoader();
    });
  }
}

@Component({
  selector: 'upload',
  templateUrl: 'file-upload.component.html',
  styleUrls: ['./style.scss']

})
export class Upload6 implements OnInit {

  constructor(public dialogRef: MatDialogRef<Upload6>, public dataStorageService: ApiService, private utilsService: UtilsService) { }
  fileToUpload: File = null;
  jsontosave
  loaded
  ngOnInit() {

  }
  handleFileInput(files: FileList) {
    var me = this
    if (files && files.length > 0) {
      let file: File = files.item(0);
      let reader: FileReader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e) => {
        let csv: string = reader.result as string;
        me.jsontosave = me.csvJSON(csv)
        me.loaded = true
      }
    }
  }
  uploadFileToActivity() {
    var me = this
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
      if (this.readyState == 4 && (this.status == 200 || this.status == 500)) {
        me.dialogRef.close();
      }
    };
    xmlHttp.open("POST", 'https://sosimperium.multiutilitydelgarda.eu:8001/csvplants', false); // false for synchronous request
    xmlHttp.setRequestHeader("Content-type", "application/json");
    xmlHttp.send(this.jsontosave);
    me.loaded = false
    // this.dataStorageService.storeCsvPlants(this.jsontosave)
  }

  csvJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {

      var obj = {};
      var currentline = lines[i].split(",");

      for (var j = 0; j < headers.length; j++) {
        if (headers[j] && currentline[j]) {
          headers[j] = headers[j].replace(/[\n\r]+/g, '');
          currentline[j] = currentline[j].replace(/[\n\r]+/g, '');
          obj[headers[j]] = currentline[j];
        }
      }

      result.push(obj);

    }
    return JSON.stringify(result); //JSON
  }
}